import { GoogleTagManagerConstants } from "./GoogleTagManagerConstants";
import { trackException } from "../../logging/AppInsightsLogger";

export const sendDataLayerEvent = (event) => {
  if (window.dataLayer) {
    window.dataLayer.push(event);
  } else {
    trackException(
      GoogleTagManagerConstants.eventTypes.failedToSendGoogleAnalyticsEvent,
      GoogleTagManagerConstants.dataLayerWasNotDefined
    );
  }
};
